module.exports = __webpack_public_path__ + "static/fonts/Nunito-Italic.2fbab16.woff2";